import SectionHeading from "./SectionHeading";
import { hotTopics } from "@/mocks/critter";

const hotWords = [
  "加盟陷阱",
  "砍价剧本",
  "培训贷",
  "自动续费",
  "会销套路",
  "低价引流",
  "美丽贷",
  "返租骗局",
  "考证包过",
  "水军",
  "会员收割",
  "私域团购",
];

export default function HotTopics() {
  return (
    <section id="hot" className="scroll-mt-24 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_340px]">
          <div>
            <SectionHeading
              eyebrow="Trending"
              title="热点追踪"
              desc="读者正在搜什么、聊什么。我们把高讨论度的话题快速核实，再去伪存真。"
            />

            <div className="mt-9 divide-y divide-background-300 rounded-lg border border-background-300 bg-background-50 px-2 md:px-4">
              {hotTopics.map((t) => (
                <a
                  key={t.rank}
                  href="#reports"
                  className="group flex items-center gap-4 px-3 py-4 transition-colors hover:bg-background-100"
                >
                  <span
                    className={`font-label text-2xl font-bold w-9 shrink-0 ${
                      t.rank <= 3 ? "text-accent-600" : "text-foreground-300"
                    }`}
                  >
                    {String(t.rank).padStart(2, "0")}
                  </span>
                  <span className="flex-1">
                    <span className="block font-heading text-[15px] font-semibold leading-snug text-foreground-900 group-hover:text-primary-700">
                      {t.title}
                    </span>
                    <span className="mt-1 block text-xs text-foreground-500">
                      <i className="ri-fire-line mr-1 text-primary-500"></i>
                      热度 {t.heat}
                    </span>
                  </span>
                  <span
                    className={`hidden sm:flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm ${
                      t.trend === "up"
                        ? "bg-primary-100 text-primary-600"
                        : t.trend === "down"
                        ? "bg-secondary-100 text-secondary-700"
                        : "bg-background-100 text-foreground-400"
                    }`}
                  >
                    <i
                      className={`${
                        t.trend === "up"
                          ? "ri-arrow-up-line"
                          : t.trend === "down"
                          ? "ri-arrow-down-line"
                          : "ri-subtract-line"
                      }`}
                    ></i>
                  </span>
                  <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-600"></i>
                </a>
              ))}
            </div>
          </div>

          {/* side card */}
          <aside className="lg:pt-1">
            <div className="rounded-lg border border-background-300 bg-background-50 p-6">
              <p className="font-label text-[11px] uppercase tracking-[0.2em] text-accent-600">本周热词</p>
              <h3 className="mt-2 font-heading text-lg font-bold text-foreground-950">
                检索热度关键词
              </h3>
              <div className="mt-5 flex flex-wrap gap-2">
                {hotWords.map((w) => (
                  <button
                    key={w}
                    type="button"
                    className="cursor-pointer rounded-full border border-background-300 bg-background-100 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:border-accent-400 hover:bg-accent-100 hover:text-accent-900 whitespace-nowrap"
                  >
                    {w}
                  </button>
                ))}
              </div>

              <div className="mt-6 rounded-md bg-secondary-100 p-4">
                <p className="flex items-center gap-2 text-sm font-semibold text-secondary-900">
                  <i className="ri-question-line"></i> 被问最多
                </p>
                <p className="mt-2 text-sm leading-relaxed text-foreground-700">
                  『如何一眼识破加盟与低价团套路？』
                </p>
                <a
                  href="#guide"
                  className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700"
                >
                  去反套路指南 <i className="ri-arrow-right-line text-xs"></i>
                </a>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}